import { edgeFunctions } from '../lib/supabase'
import { parseEdgeFunctionError } from './comercialCotacoes'
import {
  normalizeEmail,
  normalizePersonName,
  validateEmailFormat,
  validateName,
  validatePassword,
} from '../utils/userValidation'

export interface CreateUserAsAdminInput {
  email: string
  password: string
  name: string
}

export interface CreateUserAsAdminResult {
  success: boolean
  userId?: string
  error?: string
}

export async function createUserAsAdmin(
  input: CreateUserAsAdminInput,
): Promise<CreateUserAsAdminResult> {
  const name = normalizePersonName(input.name)
  const email = normalizeEmail(input.email)
  const password = input.password

  const nameValidation = validateName(name)
  if (!nameValidation.isValid) {
    return { success: false, error: nameValidation.error }
  }

  const emailValidation = validateEmailFormat(email)
  if (!emailValidation.isValid) {
    return { success: false, error: emailValidation.error }
  }

  const passwordValidation = validatePassword(password)
  if (!passwordValidation.isValid) {
    return { success: false, error: passwordValidation.error }
  }

  const { data, error } = await edgeFunctions.invoke('admin-create-user', {
    email,
    password,
    name,
  })

  if (error) {
    return { success: false, error: parseEdgeFunctionError(error, data) }
  }

  const payload = (data ?? {}) as {
    success?: boolean
    userId?: string
    error?: string
  }

  if (payload.error) {
    return { success: false, error: parseEdgeFunctionError(null, payload) }
  }

  if (!payload.success || !payload.userId) {
    return {
      success: false,
      error: 'Não foi possível concluir o cadastro. Tente novamente.',
    }
  }

  return { success: true, userId: payload.userId }
}
